import { Link } from 'react-router-dom';
import { Typography, Button as MuiButton } from '@mui/material';
import { baseUrl } from '@sda/utils/url';
import { PaddedDivider } from '@client/components/common/PaddedDivider';
import { Tip } from '@client/components/common/Tip';
import { SignupWrapper } from '../common/SignupWrapper';
import { ExplainerItem } from '../common/ExplainerItem';
import { getNextPageUrl } from '../common/utils';

const Explainer = (
  <>
    <Typography
      variant="h6"
      align="left"
      component="p"
    >
      Hosting on Side Door
    </Typography>

    <PaddedDivider
      margin="medium"
      extended
    />

    <ExplainerItem
      number={1}
      heading="Create a Profile"
      subheading="Let artists know about your space."
    />

    <PaddedDivider
      margin="medium"
      extended
    />

    <ExplainerItem
      number={2}
      heading="Create a Show Call"
      subheading={(
        <>
          <Typography
            component="span"
            color="textSecondary"
            gutterBottom
          >
            Tell artists what kind of show you'd like to host.
          </Typography>

          <Tip
            label="Tip:"
            tipText="You can also respond to artist Show Calls!"
          />
        </>
      )}
    />

    <PaddedDivider
      margin="medium"
      extended
    />

    <ExplainerItem
      number={3}
      heading="Connect"
      subheading="Message with artists, discuss the details of the show, and negotiate the ticket price and revenue split."
    />

    <PaddedDivider
      margin="medium"
      extended
    />

    <ExplainerItem
      number={4}
      heading="Book a Show"
      subheading="Decide whether or not to sell tickets through Side Door, and finalize the show details."
    />

    <PaddedDivider
      margin="medium"
      extended
    />

    <ExplainerItem
      number={5}
      heading="Showtime!"
      subheading="Prepare your space for hosting, soundcheck the artist, check-in your audience, and enjoy the show!"
    />
  </>
);

export const Host = () => (
  <SignupWrapper
    renderExplainer={Explainer}
    imgSrc={baseUrl('media/signup/sidedoorcrop-taylorlang.jpg')}
    imgTitle="Rustic Nine Golf Course. Photo: Cary Ellis."
    renderToolbar={(
      <MuiButton
        id="sda-signup-create-host-profile-button"
        component={Link}
        to={getNextPageUrl()}
        variant="contained"
        color="primary"
        size="large"
      >
        Create a Host Profile
      </MuiButton>
    )}
  />
);
